import { ANTI_MONEY_LAUNDERING, CIPC_VERIFICATION, ENTERPRISE_ANTI_MONEY_LAUNDERING, FACIAL_BIOMETRICS_VERIFY_LIVENESS, SEARCH_FCRA, FACIAL_BIOMETRICS_VERIFY, OCR_VERIFICATION } from "@/utils/constants.js";

export function handleAmlResults(data, service_name) {
    if (service_name !== ANTI_MONEY_LAUNDERING || service_name !== ENTERPRISE_ANTI_MONEY_LAUNDERING || service_name !== SEARCH_FCRA || !Array.isArray(data.nm_results)) return null;
    return [{
      type: 'custom_table',
      table: 'nm_results',
      headers: [
        'Product ID', 'Score', 'Source ID', 'Category',
        'Country', 'Sentiment Confidence Level',
        'Matched Subject', 'Highlights & URL'
      ],
      rows: data.nm_results.map(r => ({
        productId: r.productId,
        score: r.score,
        sourceId: r.sourceId,
        category: r.category,
        country: r.sourceCountry,
        sentimentConfidenceLevel: r.sentimentConfidenceLevel,
        subjectMatched: r.subjectMatched,
        highlights: r.highlights?.[0],
        url: r.url,
      }))
    }];
  }
  handleAmlResults.handledKeys = ['nm_results'];

  export function handleImageVerification(data, service_name) {
    const services = [FACIAL_BIOMETRICS_VERIFY_LIVENESS, FACIAL_BIOMETRICS_VERIFY, OCR_VERIFICATION];
    if (!services.includes(service_name)) return null;

    const images = [];

    if (data.FacialImage) {
      images.push({ label: 'Service Image', src: `data:image/jpeg;base64,${data.FacialImage}` });
    }

    if (data.document_images?.Portrait) {
      images.push({ label: 'Portrait Image', src: data.document_images.Portrait });
    }

    if (!images.length) return null;

    return [{
      type: 'images',
      label: 'Facial Comparison',
      images
    }];
  }
  handleImageVerification.handledKeys = ['FacialImage', 'document_images'];

  export function handleCipcDirectors(data, service_name) {
    if (service_name !== CIPC_VERIFICATION || !data?.Commercial?.CommercialDirectorInformation) return null;

    const result = [];
    const directors = Array.isArray(data.Commercial.CommercialDirectorInformation)
      ? data.Commercial.CommercialDirectorInformation
      : [data.Commercial.CommercialDirectorInformation];

    const active = [], historical = [];

    directors.forEach(d => {
      const status = (d.DirectorStatusCode || '').toLowerCase();
      (status === 'active' ? active : historical).push(d);
    });

    const process_group = (group, label) => {
      if (!group.length) return;
      result.push({ type: 'heading', label });

      group.forEach((director, i) => {
        const heading = director.DisplayText || `Director ${i + 1}`;
        result.push({ type: 'heading', label: heading });

        Object.entries(director).forEach(([key, value]) => {
          if (key === 'DisplayText') return;
          if (value !== null && value !== '') {
            result.push({
              type: 'input',
              key: `${label}.${heading}.${key}`,
              label: key,
              value
            });
          }
        });
      });
    };

    process_group(active, 'Active Directors');
    process_group(historical, 'Historical Directors');

    return result;
  }
  handleCipcDirectors.handledKeys = ['Commercial.CommercialDirectorInformation'];

  export function defaultDataProcessing(data, parent_key = '', service_name = '', format_label, isHandled = () => false) {
    const result = [];

      // <<< guard against null/undefined or primitives
    if (!data || typeof data !== 'object') {
      return result;
    }

    const format_key = (key, parent) => (parent ? `${parent}.${key}` : key);

    Object.entries(data).forEach(([key, value]) => {
      const current_key = format_key(key, parent_key);

      if (isHandled(current_key)) {
        return;
      }

      if (key === 'DisplayText' && typeof value === 'string' && value.trim()) {
        if (parent_key) {
          const normalized_display = format_label(value).toLowerCase();
          const normalized_key = format_label(parent_key.split('.').pop()).toLowerCase();
          if (normalized_display !== normalized_key) {
            result.push({ type: 'heading', key: current_key, label: value.trim() });
          }
        }
        return;
      }

      if (Array.isArray(value)) {
        if (!value.length) return;
        value.forEach((item, i) => {
          const item_key = `${current_key}[${i}]`;
          if (isHandled(item_key)) return;

          if (typeof item === 'object' && item !== null) {
          const nested = defaultDataProcessing(item, item_key, service_name, format_label, isHandled);
          result.push(...nested);
        } else if (item !== null && item !== '') {
          result.push({
            type: 'input',
            key: item_key,
            label: `${key} [${i}]`,
            value: item
          });
        }
        });
      } else if (typeof value === 'object' && value !== null) {
        const nested = defaultDataProcessing(value, current_key, service_name, format_label, isHandled);
        if (nested.length) {
          if (key !== 'document_images') {
            result.push({ type: 'heading', key: current_key, label: key });
          }
          result.push(...nested);
        }
      } else if (value !== null && value !== '') {
        result.push({ type: 'input', key: current_key, label: key, value });
      }
    });

    return result;
  }

  export const serviceRules = [
    handleAmlResults,
    handleImageVerification,
    handleCipcDirectors
  ];
